import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserDetails } from "@users/models/user-details.state";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root"
})
export class UserDetailsService {
  constructor(private http: HttpClient) {}

  getUserDetails(userId: string): Observable<UserDetails> {
    return this.http.get<UserDetails>(`${environment.api.uri}/users/${userId}`);
  }

  deleteUser(userDetails: UserDetails): Observable<void> {
    return this.http.delete<void>(`${environment.api.uri}/users/${userDetails.id}`);
  }

  enableUser(userId: string): Observable<void> {
    return this.http.post<void>(`${environment.api.uri}/users/${userId}/enable`, {});
  }

  disableUser(userId: string): Observable<void> {
    return this.http.post<void>(`${environment.api.uri}/users/${userId}/disable`, {});
  }

  resetAppCode(userId: string): Observable<void> {
    return this.http.post<void>(`${environment.api.uri}/users/${userId}/resetTotp`, {});
  }

  resetWebauthn(userId: string): Observable<void> {
    return this.http.post<void>(`${environment.api.uri}/users/${userId}/resetWebauthn`, {});
  }
}
